import { Link } from "react-router-dom";
import { MessageCircle, Heart, UserPlus } from "lucide-react";
import { useApp } from "../../context/AppContext";
import SEO from "../../components/SEO";
import { PageHero, WorkIcon, EmptyState, HtmlBlock } from "../../components/Bits";

export default function Work() {
  const { t, L, site } = useApp();
  const areas = site?.work_areas || [];
  const s = site?.settings || {};
  const wa = s.whatsapp || "917897477893";

  return (
    <div data-testid="work-page">
      <SEO title={t("work")} description="Education, healthcare, social security, disability empowerment, women and child welfare, skill development, community development and relief work." />
      <PageHero title={t("work")} sub={lang_sub()} />
      <section className="py-16 sm:py-20">
        <div className="container-ssf space-y-6">
          {areas.length === 0 && <EmptyState />}
          {areas.map((a, i) => (
            <article key={a.id} id={a.slug} data-testid={`work-area-${a.slug}`}
              className={`card-ssf grid gap-6 p-8 md:grid-cols-[auto_1fr_auto] md:items-center ${i % 2 ? "bg-cream" : ""}`}>
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-brandgreen-100 text-brandgreen">
                <WorkIcon name={a.icon} className="h-8 w-8" />
              </div>
              <div>
                <h2 className="font-display text-2xl font-bold tracking-tight text-navy">{L(a, "title")}</h2>
                <HtmlBlock html={L(a, "desc") || L(a, "short_desc")} className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-600" testid={`work-desc-${a.slug}`} />
                {a.stats && <p className="mt-3 inline-flex rounded-full bg-saffron-100 px-3 py-1 text-xs font-bold uppercase tracking-wider text-saffron-600" data-testid={`work-stats-${a.slug}`}>{a.stats}</p>}
                {a.image && <img src={a.image} alt={L(a, "title")} className="mt-4 max-h-56 w-full max-w-2xl rounded-xl object-cover" loading="lazy" data-testid={`work-image-${a.slug}`} />}
              </div>
              <div className="flex flex-wrap gap-2 md:flex-col">
                <Link to="/donate" className="btn-primary !px-5 !py-2.5 text-sm" data-testid={`work-donate-${a.slug}`}><Heart size={14} /> {t("donate")}</Link>
                <Link to="/register" className="btn-ghost !px-5 !py-2.5 text-sm" data-testid={`work-volunteer-${a.slug}`}><UserPlus size={14} /> {t("join_volunteer")}</Link>
                <a href={`https://wa.me/${wa}?text=${encodeURIComponent(L(a, "title"))}`} target="_blank" rel="noreferrer"
                  className="btn-ghost !px-5 !py-2.5 text-sm" data-testid={`work-whatsapp-${a.slug}`}><MessageCircle size={14} /> WhatsApp</a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );

  function lang_sub() {
    const { lang } = { lang: undefined };
    return "Education, healthcare, social security, disability empowerment, women and child welfare, skill development, community development and relief work.";
  }
}
